<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default {
  name: "AppRLTS",
  mounted() {
    // Évènements de navigation entre les pages
    window.scrollTo({ top: 0});
    window.addEventListener('keydown', this.handleEscapeKey);

    // Chargement de gsap et scrollTrigger
    gsap.registerPlugin(ScrollTrigger);

    // Animation scroll
    let sections = gsap.utils.toArray("section"),
        currentSection = sections[0];

    gsap.set("body", { height: (sections.length * 60) + "vh" });

    sections.forEach((section, i) => {
      ScrollTrigger.create({
        pinned: true,
        start: () => (i - 0.1) * innerHeight * 0.4,
        end: () => (i + 0.2) * innerHeight * 0.4,
        onToggle: self => self.isActive && setSection(section),
      });
    });

    // Caroussel des photos
    document.addEventListener("DOMContentLoaded", () => {
      const container = document.querySelector(".pic-container");
      const pics = document.querySelectorAll(".pic");

      let imagesLoaded = 0;
      let heightPics = 0;

      pics.forEach((pic) => {
        pic.addEventListener("load", () => {
          imagesLoaded++;
          if (imagesLoaded === pics.length) {

            pics.forEach((pic) => {
              heightPics += pic.height;
            })

            pics.forEach((pic) => {
              const clone = pic.cloneNode(true);
              container.appendChild(clone);
            });

            setTimeout(() =>{
              gsap.to(container, {
                y: -heightPics,
                duration: 25,
                ease: "none",
                repeat: -1,
              });
            }, 50);
          }
        });
      })
    });

    function setSection(newSection) {
      if (newSection !== currentSection) {

        var tl = gsap.timeline({
          defaults: {
            duration: 0.5,
            overwrite: "auto",
          }
        })
        tl.to(newSection, {scale: 1, autoAlpha: 1})
            .to(currentSection, {scale: 1.2, autoAlpha: 0}, "<")

        const h1Element = newSection.querySelector("h1");
        if (h1Element) {
          tl.from(h1Element, { autoAlpha: 0, y: -40 }, "<");
        }

        const h3Elements = newSection.querySelectorAll("h3");
        if (h3Elements.length > 0) {
          tl.from(h3Elements, { autoAlpha: 0, y: -80 }, "<");
        }

        const pElement = newSection.querySelectorAll("p");
        if (pElement.length > 0) {
          tl.from(newSection.querySelectorAll("p"), {autoAlpha: 0, x:20}, ">");
        }

        currentSection = newSection;
      }
    }
    ScrollTrigger.create({
      start: 1,
    }).scroll(2);

  },
  beforeUnmount() {
    gsap.set("body", { height: "auto" });
    window.removeEventListener('keydown', this.handleEscapeKey);
  },
  methods: {
    handleEscapeKey(event) {
      if (event.key === "Escape") {
        this.$router.push('/'); // Redirection vers la page d'accueil
      }
    }
  }
}
</script>
<template>
<div id="rlts">
  <nav>
    <div class="back-btn">
      <router-link to="/"><img src="@/assets/images/icon/back.svg" alt="back-btn"></router-link>
    </div>
  </nav>
  <section class="section first" id="headGrid">
    <div class="item gridTitle">
      <h1>Rocket League Top Scorer</h1>
    </div>

    <div class="item rltsLogo-ctn">
      <img id="rltsLogo" src="@/assets/images/logo/rltsLogo.png">
    </div>
    <div class="item gridTech">
      <img src="@/assets/images/logo/python.png" alt="Python">
      <img src="@/assets/images/logo/discord-py.png" alt="Disord Python">
      <img class="bg-white" src="@/assets/images/logo/flask.png" alt="Flask">
    </div>
    <div class="item gridInfos">
      <p><span class="bold">Date</span> : 05/2024 - 12/2024</p>
      <p><span class="bold">Statut</span> : Développeur Freelance</p>
      <p><span class="bold">Entreprise</span> : KNY Production</p>
      <p><span class="bold">Équipe</span> : 2 développeurs</p>
    </div>
  </section>
  <section class="section" id="gridProject">
    <div class="item gridTitle">
      <h1>Le Projet</h1>
    </div>
    <div class="item gridTrailer">
      <video id="trailerVideo" controls autoplay muted>
        <source src="@/assets/videos/trailerRLTS.mp4" type="video/mp4">
        Your browser does not support background videos.
      </video>
    </div>
    <div class="item gridMediaFooter">
      <p>LE TRAILER</p>
    </div>
    <div class="item gridParagraph">
      <p>Le projet est un tournoi E-Sport sur le jeu vidéo Rocket League, avec un format original nommé le "Top Scorer".</p>
      <p>Son principe est de permettre aux joueurs de n'importe quel niveau de participer. Plus ils gagnent de matchs, plus ils marquent de points,
        plus ils jouent contre des équipes fortes.</p>
      <p>Le streamer Twitch <a href="https://twitch.tv/kennystream" target="_blank">KennyStream</a>, organisateur du tournoi, m'a solicité pour réalisé un script de gestion de tournoi.</p>
      <p>Voyant que le format fonctionnait bien, il a décidé de voir plus grand avec une compétition sur 5 semaines, avec 5000€ a gagner, le tout en partenariat avec Rocket League.</p>
    </div>
  </section>
  <section class="section" id="gridMission">
    <div class="item gridTitle">
      <h1>La Mission</h1>
    </div>
    <div class="item gridArticle">
      <h3>Le script</h3>
      <p>Mon rôle dans le projet était d'assurer le bon déroulement des 4 qualifications,
        qui premettent d'accéder à la grande finale, en plateau à Montpellier.
        </p>
      <p>J'ai donc réalisé un script python permettant à un format de cette complexité, d'être géré facilement.
        Ce dernier permet de définir les rencontres entre chaque équipe en fonction de leur score.
        </p>
    </div>
    <div class="item gridArticle">
      <h3>Le Bot Discord</h3>
      <p>En plus de la gestion des rencontres, le script communique les informations du tournoi en temps réel,
        à travers un bot discord, réalisé avec l'api python <a href="https://discordpy.readthedocs.io/en/stable/" target="_blank">Discord.py</a> .
        </p>
      <p>Cet ajout permettait aux participants de connaître leur score, le classement, ainsi que les matchs qu'ils devaient jouer.
        C'était très pratique pour les participants et les organisateurs, de pouvoir communiquer ensemble, tout en ayant les informations au même endroit.
      </p>
    </div>
  </section>
  <section class="section" id="gridWebsite">
    <div class="item gridTitle">
      <h1>Le Site Web</h1>
    </div>
    <div class="item gridImage">
      <img id="websiteImg" src="@/assets/images/rlts.png">
    </div>
    <div class="item gridMediaFooter">
      <p>CAPTURE D'ÉCRAN DU SITE</p>
    </div>
    <div class="item gridParagraph">
      <p>Le site web du tournoi, à été réalisé par un autre développeur qui travaillait avec moi sur le projet.
        Ce site permettait aux joueurs de s'inscrire au tournoi, ce qui les enregistrait dans notre base de données.</p>
      <p>Mon script récupérait alors ces données pour le déroulement du tournoi.
        De plus, le site faisait office de vitrine pour le tournoi, avec sa page d'accueil (la seule partie du site que j'ai réalisé).
        Il permettait aussi au spectateur d'avoir accès au classement du tournoi.
      </p>
      <p><a id="see" href="https://knystream.tv/" target="_blank">➤ VOIR LE SITE</a></p>
    </div>
  </section>
  <section class="section" id="gridFinals">
    <div class="item gridTitle">
      <h1>La Grande Finale</h1>
    </div>
    <div class="item gridImgCaroussel">
      <div class="pic-container">
        <img class="pic" src="@/assets/images/rlts/DSC05135_lightroom.jpg">
        <img class="pic" src="@/assets/images/rlts/DSC05049_lightroom.jpg">
        <img class="pic" src="@/assets/images/rlts/DSC05046_lightroom.jpg">
      </div>
    </div>
    <div class="item gridMediaFooter">
      <p class="rltsFt"><span style="color: yellow;">🗲</span> ROCKET LEAGUE TOP SCORER <span style="color: yellow;">🗲</span></p>
    </div>
    <div class="item gridParagraph">
      <p>Le moment où le projet se concrétise après 4 semaines qualfications pour les joueurs, de travail acharné pour mon équipier et moi-même.</p>
      <p>Une fois les 4 qualifications terminées, mon rôle de développeur était terminé,
        mais j'ai été invité a assiter à la grande finale, dans les studios de France TV à Montpellier.
      </p>
      <p>
        Les 4 équipes qualifiées se sont alors déplacées pour s'affronter sur ce plateau, dans un format plus classique (demi-finals puis final).
        L'équipe qui a gagné la finale est repartie avec le prix des 5000€, bravo à eux pour cette performance !
      </p>
      <p>Voici quelques images de ce moment magnifque !</p>
    </div>
  </section>
  <section class="section" id="gridLinks">
    <div class="gridTitle">
      <h1>Liens externes</h1>
    </div>
    <div class="gridLinks">
      <ul>
        <li><a href="https://twitch.tv/kennystream" target="_blank">La chaîne Twitch de Kenny</a></li>
        <li><a href="https://www.youtube.com/watch?v=5BcywIkg-Ck" target="_blank">La rediffusion complète des finals en plateau</a></li>
        <li><a href="https://www.youtube.com/watch?v=m59sCMqBgyI&list=PL6OgkvLrDjqXkDvSuwQW8-7BH_UjF4D3M" target="_blank">Les rediffusions des qualifications</a></li>
      </ul>
      <div class="item low-back-btn"><router-link to="/">Retour à l'accueil</router-link></div>
    </div>

  </section>
</div>
</template>
<style>

  #rlts{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .section{
    position: fixed;
    width: 90%;
    height: 80vh;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: linear-gradient(108deg, #0e1841, #1b2963);
  }

  .section:nth-of-type(2n) {
    background: linear-gradient(108deg, #1b2963, #0e1841);
  }

  .section:not(.first) {
    opacity: 0;
    visibility: hidden;
    transform: translate(-50%, -50%) scale(1.2);
  }

  #rlts h1{
    text-transform: uppercase;
    font-size: 5vw;
    margin: 4vh;
  }

  #headGrid{
    display: grid;
    grid-template-columns: 1fr 4fr;
    grid-template-rows: 1fr 1fr 2fr;
    border: solid 2px #8cffff;
  }

  .item{
    border: solid 2px #8cffff;
  }

  .gridTitle{
    grid-column: span 2;
  }

  .rltsLogo-ctn{
    grid-row: span 2;
    aspect-ratio: 1 / 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #rltsLogo{
    width: 80%;
  }

  .gridTech{
    grid-column: 2;
    grid-row: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4vw;
  }

  .gridTech img{
    height: 6vw;
  }

  .gridInfos{
    grid-column: 2;
    grid-row: 3;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding-left: 5vh;
    font-size: 2.8vw;
  }

  .gridInfos p{
    font-size: 3vw;
  }

  #gridProject{
    height: 90vh;
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-template-rows: 3fr 8fr 1fr;
    border: solid 2px #8cffff;
  }

  .gridParagraph{
    grid-column: 2;
    grid-row: span 2;
    display: flex;
    flex-direction: column;
    gap: 1.5vh;
    justify-content: start;
    text-align: left;
    padding: 2vw 1.6vw;
  }

  .gridParagraph p{
    font-size: 1.5vw;
  }

  .gridTrailer{
    grid-column: 1;
    grid-row: 2;
    position: relative;
  }

  .gridMediaFooter{
    grid-column: 1;
    grid-row: 3;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .gridMediaFooter p{
    font-size: calc(100%);
    font-weight: 500;
  }

  #trailerVideo{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  #gridMission{
    display: grid;
    grid-template-columns: 2fr 2fr;
    grid-template-rows: 1fr 3fr;
    border: solid 2px #8cffff;
  }
  .gridArticle{
    display: flex;
    flex-direction: column;
    gap: 1.5vh;
    justify-content: start;
    align-items: center;
    padding: 1.6vw 2vw;
  }

  .gridArticle h3{
    text-transform: uppercase;
    font-size: 8vh;
    margin: 0;
  }

  .gridArticle p{
    text-align: left;
    font-size: 1.5vw;
  }

  #gridWebsite{
    height: 90vh;
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-template-rows: 3fr 8fr 1fr;
    border: solid 2px #8cffff;
  }

  #see{
    margin-top: 1.6vh;
    font-size: 2.6vw;
  }

  .gridImage{
    position: relative;
  }

  #websiteImg{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  #gridFinals{
    height: 90vh;
    display: grid;
    grid-template-columns: 2fr 2fr;
    grid-template-rows: 1fr 3fr;
    border: solid 2px #8cffff;
  }

  #gridFinals .gridTitle{
    grid-column: span 3;
  }

  .gridImgCaroussel{
    overflow: hidden;
    position: relative;
  }

  .pic-container{
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  .pic{
    position: relative;
    width: 100%;
    height: auto;
    border-bottom: 4px solid #8cffff;
  }

  .rltsFt{
    margin: 1.6vh 0 1.6vh 0;
  }

  .gridMediaFooter .rltsFt{
    font-size: 4.6vh;
  }

  #gridLinks{
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 3fr;
    border: solid 2px #8cffff;
  }

  .gridLinks{
    display: flex;
    flex-direction: column;
    gap: 1.5vh;
    justify-content: start;
    align-items: center;
    font-size: 4.6vh;
  }

  #gridLinks ul{
    list-style: none;
    margin: 0;
  }

  #gridLinks li{
    margin-bottom: 4vh;
  }

  .low-back-btn{
    background: linear-gradient(24deg, #293980, #1b2862);
    border-radius: 12px;
    margin-top: 1vh;
    padding: 1.2vh 2vw;
  }

  .low-back-btn a{
    color: #8cffff;
  }

  @media (max-width: 480px) {
    #headGrid{
      grid-template-columns: 3fr 1fr;
      grid-template-rows: 1fr 2fr 3fr;
    }

    .rltsLogo-ctn {
      grid-row: auto;
    }

    .gridTech{
      grid-column: auto;
      grid-row: auto;
      flex-direction: column;
      gap: 5vh;
    }

    .gridTech img {
      width: 50%;
      height: auto;
    }

    .gridInfos{
      grid-column: span 2;
      padding-left: 0;
    }

    .gridInfos p {
      font-size: 5vw;
    }

    #gridProject{
      height: 80vh;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 4fr 1fr 5fr;
    }

    .gridTrailer {
      grid-column: span 2;
      grid-row: auto;
    }

    .gridMediaFooter {
      grid-column: span 2;
      grid-row: auto;
    }

    .gridParagraph {
      grid-column: span 2;
      grid-row: auto;
    }

    .gridParagraph p{
      font-size: 3.2vw;
    }

    #gridMission{
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr 3fr 1fr 3fr;
      border: solid 2px #8cffff;
    }

    #gridWebsite{
      height: 80vh;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 3fr 1fr 5fr;
    }

    .gridImage{
      grid-column: span 2;
    }

    .gridArticle{
      grid-column: span 2;
      padding-bottom: 3vh;
    }

    .gridArticle h3 {
      font-size: 7vw;
    }

    .gridArticle p{
      font-size: 3.6vw;
    }

    #gridFinals {
      height: 80vh;
      grid-template-rows: 1fr 6fr;
    }

    .gridLinks {
      font-size: 3vh;
    }

    .gridLinks ul{
      padding: 4vw;
    }
  }
</style>